module.exports = __webpack_public_path__ + "img/new_customer_status.4de9c195.svg";